<!-- CONTENT CARD -->
<div class="content-card"> 
    <ngx-datatable 
        #table 
        class='material striped' 
        [loadingIndicator]="loadingIndicator"
        [columns]="columns"
        [columnMode]="'force'" 
        [headerHeight]="50"
        [footerHeight]="50" 
        [rowHeight]="'auto'"
        (sort)="onSort($event)"                
        [rows]='rows'>

        <ngx-datatable-column name="Data" prop="data_referencia" [sortable]="false">
            <ng-template let-rowIndex="rowIndex" let-data_referencia="value" ngx-datatable-cell-template>
                {{data_referencia | date:'dd/MM/yyyy'}}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="false" [width]="300">
            <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template>
                {{cliente.numero_xp}} - {{cliente.nome}}
            </ng-template>
        </ngx-datatable-column>
        
        <ngx-datatable-column name="Assessor" prop="cliente" [sortable]="false">
            <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template>
                {{ cliente.assessor?.name  }}
            </ng-template>
        </ngx-datatable-column> 
        
        <ngx-datatable-column name="Ativo" prop="ativo" [sortable]="false" >
            <ng-template let-rowIndex="rowIndex" let-ativo="value" ngx-datatable-cell-template>
                {{ ativo.sigla }}
            </ng-template>
        </ngx-datatable-column>   

        <ngx-datatable-column name="Qtd" prop="qtd" [sortable]="false" >
            <ng-template let-rowIndex="rowIndex" let-qtd="value" ngx-datatable-cell-template>
                {{ qtd | number : '1.0-0' }}
            </ng-template>
        </ngx-datatable-column>    

        <ngx-datatable-column name="Valor" prop="valor" [sortable]="false">
            <ng-template let-rowIndex="rowIndex" let-valor="value" ngx-datatable-cell-template>
                R$ {{ valor | number : '1.2-2' }}
            </ng-template>
        </ngx-datatable-column>               
        

        <ngx-datatable-column name="Ação" prop="id" [sortable]="false" [width]="80">
            <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>

                <button 
                    mat-icon-button 
                    color="primary" 
                    matTooltip="Gerar Boleta" 
                    (click)="openCadastro(row)"
                >
                    <mat-icon aria-label="Visualizar Boleta">attach_money</mat-icon>
                </button>

                <button 
                    mat-icon-button 
                    color="warn" 
                    matTooltip="Excluir Boleta" 
                    (click)="delete(row)"
                >
                    <mat-icon aria-label="Excluir Boleta">delete</mat-icon>
                </button>

            </ng-template>
        </ngx-datatable-column>

    </ngx-datatable>

    <div style="padding: 5px 10px">
        <mat-paginator 
            #paginator 
            [length]="length"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (page)="pageEvent($event)">
        </mat-paginator>
    </div>
</div>
